import { Component, OnInit, OnDestroy, ViewChildren } from "@angular/core";
import { KpiService } from "../kpi/kpi.service";
import { Observable, Subscription } from "rxjs";
import { school } from "../store/schools/state";
import { has, keys } from "lodash";
import { OOPS_MESSAGES } from "../constants";
import { DistrictSchools } from "../shared/interfaces";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
  selector: "home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.scss"],
})
export class HomeComponent implements OnInit, OnDestroy {
  metadata;
  metadataLoading: boolean = true;
  role: string;
  hasAllSchools: boolean;
  tier: string;

  districtProfileMetadataSub: Subscription;
  districtSchoolsMetadataSub: Subscription;
  userInfoSub: Subscription;
  districtSchoolsSub: Subscription;
  flagSubscription: Subscription;
  filterCategories = [];
  filterSubcategories = [];
  filterValues = [];
  selectedCategory: string;
  selectedSubcategory: string;
  schoolsMetadata;
  schoolsMetadataLoading: boolean = true;
  noFilterText: string = "- No filter -";

  @ViewChildren("Panel") panels: any;

  constructor(
    public kpiService: KpiService,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit() {
    this.kpiService.errorMessage = null;
    this.districtProfileMetadataSub = this.kpiService
      .getDistrictProfileMetadata()
      .subscribe(
        (data) => {
          this.metadata = data;
          this.metadataLoading = false;
        },
        (error) => {
          this.handleError(error);
        }
      );
    this.userInfoSub = this.kpiService.getUserInfo().subscribe(
      (data) => {
        this.role = data.role;
        this.tier = data.sz_tier;
        this.kpiService.title = data.customer_name;
        this.districtSchoolsSub = this.kpiService
          .getDistrictSchools()
          .subscribe(
            (districtSchoolsJson: DistrictSchools) => {
              if (has(data, "hasAllSchools")) {
                this.hasAllSchools = data.hasAllSchools;
              } else if (this.role == "admin") {
                this.hasAllSchools = true;
              } else if (this.role == "school_leader") {
                this.hasAllSchools =
                  data &&
                  data.schools &&
                  districtSchoolsJson &&
                  districtSchoolsJson.schools &&
                  data.schools.length == districtSchoolsJson.schools.length;
              } else {
                this.hasAllSchools = false;
              }
              this.schoolsMetadata = {
                ...districtSchoolsJson.demographics,
                "School Level": districtSchoolsJson.schoolLevels,
                "School Region": districtSchoolsJson.schoolRegions,
              };
              this.filterCategories = [
                this.noFilterText,
                ...Object.keys(this.schoolsMetadata),
              ];
              let urlParamMap = this.activatedRoute.snapshot.queryParamMap;
              if (
                has(urlParamMap, "params") &&
                urlParamMap["params"] &&
                keys(urlParamMap["params"]) &&
                keys(urlParamMap["params"]).length > 0
              ) {
                // we have url parameters in our route
                this.selectedCategory = urlParamMap.get("filter");
                this.selectedSubcategory = urlParamMap.get("demographic");
                this.filterSubcategories = [
                  this.noFilterText,
                  ...this.schoolsMetadata[this.selectedCategory],
                ];
              }
              this.schoolsMetadataLoading = false;
            },
            (err) => {
              this.schoolsMetadataLoading = false;
              console.log(err);
            }
          );
      },
      (error) => {
        this.handleError(error);
      }
    );
  }

  ngOnDestroy() {
    if (this.districtProfileMetadataSub) {
      this.districtProfileMetadataSub.unsubscribe();
    }
    if (this.userInfoSub) {
      this.userInfoSub.unsubscribe();
    }
    if (this.districtSchoolsSub) {
      this.districtSchoolsSub.unsubscribe();
    }
    if (this.districtSchoolsMetadataSub) {
      this.districtSchoolsMetadataSub.unsubscribe();
    }
    if (this.flagSubscription) {
      this.flagSubscription.unsubscribe();
    }
  }

  trackPanelFn(index) {
    return index;
  }

  handleError(error) {
    this.kpiService.showError(
      error,
      OOPS_MESSAGES.ACCESS_CONTENT,
      OOPS_MESSAGES.RENDER_DASHBOARD
    );
  }

  selectFilterCategory() {
    this.selectedSubcategory = null;
    if (this.selectedCategory == this.noFilterText) {
      this.selectedCategory = null;
    } else {
      this.filterSubcategories = [
        this.noFilterText,
        ...this.schoolsMetadata[this.selectedCategory],
      ];
    }
    this.updateUrlParams();
  }

  selectFilterSubcategory() {
    if (this.selectedSubcategory == this.noFilterText) {
      this.clearFilters();
    }
    this.updateUrlParams();
    this.resetChartsToOverall();
  }

  clearFilters() {
    this.selectedCategory = null;
    this.selectedSubcategory = null;
    this.filterSubcategories = [];
    this.updateUrlParams();
  }

  updateUrlParams() {
    let queryParams = { ...this.activatedRoute.snapshot.queryParams };
    queryParams = {
      ...queryParams,
      filter: this.selectedCategory,
      demographic: this.selectedSubcategory,
    };
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams,
    });
  }

  resetChartsToOverall() {
    this.panels.forEach((panel) => {
      panel.resetChartsToOverall();
    });
  }
}
